<template lang="html">
  <div
    class="h-screen max-w-4xl mx-auto"
  >
  <Background class="z-0 overflow-hidden" :colour="randomColour" />
  <div class="z-30 relative">
    <MainHeader />
    <Question
      :question="questions[$route.params.id].question"
      :answers="questions[$route.params.id].answers"
      :colours="colours"
      :level="questions[$route.params.id].level"
      :lastEntry="isLast"
      :result="pushResult"
      />
    <MainFooter :dots="dots" :current="questions[$route.params.id].Number" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Background from "@/components/bg/Background.vue"
import MainHeader from "@/components/header/MainHeader.vue"
import MainFooter from "@/components/footer/MainFooter.vue"
import Question from "@/components/content/Question.vue"

export default {
  name: "Single",
  components: {
   Background,
   MainHeader,
   Question,
   MainFooter
  },
  data() {
    return {
      dots: [1,2,3,4,5,6,7,8,9,10],
      randomColour:[],
      colours:[
        { bg: "herored", img: require('@/assets/img/SVG/BGred.svg') },
        { bg: "heroyellow", img: require('@/assets/img/SVG/BGorange.svg') },
        { bg: "heroblue", img: require('@/assets/img/SVG/BGblue.svg') }
      ],
      questions: []
    }
  },
  watch: {
    "$route.params": {
      handler(newValue) {
        if (newValue) {
          this.getQuestions()
          this.colourRandom()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getQuestions()
    this.colourRandom()
  },
  methods: {
    colourRandom() {
        let randomValue = this.colours[Math.floor(Math.random() * this.colours.length)];
        this.randomColour = randomValue
    },
    getQuestions() {
        if(this.$route.params.level == 'entry'){
            this.questions = require( "@/data/entry/questions.json")
        }
        if(this.$route.params.level == 'A'){
            this.questions = require( "@/data/A/questions.json")
        }
        if(this.$route.params.level == 'B'){
            this.questions = require( "@/data/B/questions.json")
        }
        if(this.$route.params.level == 'C'){
            this.questions = require( "@/data/C/questions.json")
        }
        if(this.$route.params.level == 'T'){
            this.questions = require( "@/data/T/questions.json")
        }
      //  A : require( "@/data/A/questions.json"),
      //  B : require( "@/data/B/questions.json"),
      //  C : require( "@/data/C/questions.json")
    }
  },
  computed: {
    pushResult() {
      var result = true
      if(this.$route.params.level == 'entry' || this.$route.params.level == 'T') {
        result = false
      }
      return result
    },
    isLast() {
        var result = false
        if((this.lastEntry) == Number(this.$route.params.id + 1)) {
          result = true
        }
        return result
    },
    lastEntry() {
      let questions = this.questions
      return questions.length
    }
  }
}
</script>
